module.exports = __webpack_public_path__ + "static/media/road-glide-special-midnight-crimson.42c41616.png";